(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rm-enquiry-reference"] && !Shopify.designMode) return;
  try {
    (() => {
  function initialize(scope) {
    scope.querySelectorAll('form[data-rm-enquiry]').forEach(form => {
      if (form.dataset.rmReferenceReady) return;
      const settings = form.querySelector('.rm-enquiry-settings');
      if (!settings) return;
      const bytes = crypto.getRandomValues(new Uint8Array(6));
      const random = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('').toUpperCase();
      const date = new Intl.DateTimeFormat('en-GB', {timeZone:'Asia/Dubai',year:'2-digit',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
      const part = type => date.find(item => item.type === type).value;
      const reference = '1RM-' + form.dataset.rmEnquiry + '-' + part('year') + part('month') + part('day') + '-' + random;
      const type = settings.dataset.enquiryType;
      const format = value => value.replaceAll('{reference}',reference).replaceAll('{type}',type);
      const whatsapp = 'https://wa.me/971565664886?text=' + encodeURIComponent(format(settings.dataset.whatsapp));
      form.querySelector('[data-rm-reference]').value = reference;
      form.elements.namedItem('_subject').value = format(settings.dataset.subject);
      form.elements.namedItem('_autoresponse').value = format(settings.dataset.acknowledgement).replaceAll('{whatsapp}',whatsapp);
      const next = new URL(form.elements.namedItem('_next').value);
      next.searchParams.set('ref', reference);
      form.elements.namedItem('_next').value = next.href;
      const display = form.querySelector('[data-rm-reference-display]');
      display.textContent = reference;
      display.parentElement.hidden = false;
      form.querySelectorAll('[data-rm-submit]').forEach(button => button.disabled = false);
      form.dataset.rmReferenceReady = 'true';
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rm-equipment-enquiry"] && !Shopify.designMode) return;
  try {
    (() => {
  const form = document.getElementById('rm-equipment-upload');
  if (!form) return;
  const upload = document.getElementById('rm-attachment');
  const error = document.getElementById('rm-file-error');
  const status = document.getElementById('rm-submit-status');
  const messages = JSON.parse(form.dataset.messages);
  const MAX_BYTES = 10000000;
  const accepted = /\.(pdf|jpe?g|png|webp|gif|hei[cf])$/i;
  function validateUpload() {
    const files = upload.files;
    let message = '';
    if (files.length > 1) message = messages.single;
    else if (files.length === 1 && files[0].size > MAX_BYTES) message = messages.too_large;
    else if (files.length === 1 && !accepted.test(files[0].name)) message = messages.file_type;
    upload.setCustomValidity(message);
    upload.setAttribute('aria-invalid', message ? 'true' : 'false');
    error.textContent = message;
    error.hidden = !message;
    return !message;
  }
  upload.addEventListener('change', validateUpload);
  form.addEventListener('submit', event => {
    if (!validateUpload()) { event.preventDefault(); upload.reportValidity(); return; }

  });
  if (form.dataset.deliveryEnabled === 'true' && new URLSearchParams(location.search).get('enquiry') === 'received') {
    form.hidden = true;
    document.getElementById('rm-equipment-success').hidden = false;
    document.getElementById('rm-equipment-success').focus();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rm-phone-fields"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.rmPhoneFieldsReady) return;
  window.rmPhoneFieldsReady = true;
  const config = document.getElementById('rm-phone-config');
  if (!config) return;
  const countries = JSON.parse(config.dataset.countries);
  if (document.documentElement.lang === 'ar' && typeof Intl.DisplayNames === 'function') {
    const regionNames = new Intl.DisplayNames(['ar'], {type:'region'});
    countries.forEach(country => { try { country[1] = regionNames.of(country[0]) || country[1]; } catch (_) {} });
  }
  const labels = JSON.parse(config.dataset.labels);
  const byCode = new Map(countries.map(country => [country[0], country]));
  const fields = new Set();
  const preferred = ['AE', 'SA', 'OM', 'QA', 'KW', 'BH', 'GB', 'US', 'IN'];
  const ordered = [...preferred.map(code => byCode.get(code)), ...countries.filter(country => !preferred.includes(country[0]))];
  const flag = code => [...code].map(letter => String.fromCodePoint(127397 + letter.charCodeAt(0))).join('');
  const readSaved = key => { try { return sessionStorage.getItem(key); } catch (_) { return null; } };
  const save = (key, value) => { try { sessionStorage.setItem(key, value); } catch (_) {} };
  let manualCountry = readSaved('rm-phone-country-choice');
  let detectedCountry = readSaved('rm-phone-country-ip') || 'AE';
  let geoStarted = false;
  function countryForNumber(value, current) {
    const number = value.trim().replace(/^00/, '+').replace(/[^+\d]/g, '');
    if (!number.startsWith('+')) return null;
    if (number.startsWith('+' + byCode.get(current)[2])) return current;
    const matching = countries.filter(c => number.startsWith('+' + c[2]));
    matching.sort((a,b) => String(b[2]).length - String(a[2]).length || preferred.indexOf(b[0]) - preferred.indexOf(a[0]));
    return matching[0]?.[0] || null;
  }
  function international(value, country) {
    const trimmed = value.trim();
    if (!trimmed) return '';
    if (/^(\+|00)/.test(trimmed)) return '+' + trimmed.replace(/^00/, '').replace(/\D/g, '');
    let digits = trimmed.replace(/\D/g, '');
    const prefix = country[3];
    if (prefix && /^\d+$/.test(prefix) && !['IT', 'VA', 'SM'].includes(country[0]) && digits.startsWith(prefix) && digits.length > prefix.length + 4) digits = digits.slice(prefix.length);
    return '+' + country[2] + digits;
  }
  function paint(field) {
    const country = byCode.get(field.country);
    field.select.value = field.country;
    field.flag.textContent = flag(field.country);
    field.select.title = country[1] + ' +' + country[2];
    field.select.setAttribute('aria-label', labels.country + ': ' + country[1] + ' +' + country[2]);
    field.wrapper.dataset.country = field.country;
  }
  function setValue(input, value) {
    if (input.value === value) return;
    const setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
    setter.call(input, value);
    input.dispatchEvent(new Event('input', {bubbles:true}));
    input.dispatchEvent(new Event('change', {bubbles:true}));
  }
  function validate(field) {
    const input = field.input;
    const value = international(input.value, byCode.get(field.country));
    const code = '+' + byCode.get(field.country)[2];
    const hasNumber = value !== '' && value !== code;
    const digits = value.replace(/\D/g, '');
    const invalid = (!hasNumber && input.required) || (hasNumber && (digits.length < String(byCode.get(field.country)[2]).length + 4 || digits.length > 15));
    input.setCustomValidity(invalid ? labels.invalid : '');
    return !invalid;
  }
  function choose(field, code, manual) {
    if (!byCode.has(code)) return;
    const previous = byCode.get(field.country);
    let value = field.input.value.trim();
    const oldPrefix = '+' + previous[2];
    if (value.startsWith(oldPrefix)) value = value.slice(oldPrefix.length).trim();
    field.country = code;
    if (manual) {
      field.touched = true;
      manualCountry = code;
      save('rm-phone-country-choice', code);
    }
    paint(field);
    setValue(field.input, value ? international(value, byCode.get(code)) : '+' + byCode.get(code)[2] + ' ');
    validate(field);
  }
  function detectCountry() {
    if (geoStarted || readSaved('rm-phone-country-ip')) return;
    geoStarted = true;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 4000);
    fetch((window.Shopify?.routes?.root || '/') + 'browsing_context_suggestions.json?country[enabled]=true', {credentials:'same-origin', signal:controller.signal})
      .then(response => response.ok ? response.json() : null)
      .then(result => {
        const code = result?.detected_values?.country?.handle?.toUpperCase();
        if (!byCode.has(code)) return;
        detectedCountry = code;
        save('rm-phone-country-ip', code);
        fields.forEach(field => { if (!manualCountry && !field.touched && field.input.isConnected) choose(field, code, false); });
      }).catch(() => {}).finally(() => clearTimeout(timeout));
  }
  function enhance(input) {
    if (input.dataset.rmPhoneReady || input.disabled || input.readOnly || input.closest('.iti, .intl-tel-input, [data-rm-phone-ignore]')) return;
    input.dataset.rmPhoneReady = 'true';
    const wrapper = document.createElement('div');
    wrapper.className = 'rm-phone-control';
    const picker = document.createElement('div');
    picker.className = 'rm-phone-picker';
    const icon = document.createElement('span');
    icon.className = 'rm-phone-flag';
    icon.setAttribute('aria-hidden','true');
    const arrow = document.createElement('span');
    arrow.className = 'rm-phone-arrow';
    arrow.textContent = '▾';
    arrow.setAttribute('aria-hidden','true');
    const select = document.createElement('select');
    select.className = 'rm-phone-country';
    select.autocomplete = 'off';
    ordered.forEach(country => { const option = new Option(flag(country[0]) + ' ' + country[1] + ' (+' + country[2] + ')', country[0]); select.add(option); });
    picker.append(icon,arrow,select);
    input.before(wrapper);
    wrapper.append(picker,input);
    input.setAttribute('inputmode','tel');
    input.setAttribute('autocomplete','tel');
    input.setAttribute('dir','ltr');
    if (!input.getAttribute('aria-label') && !input.id) input.setAttribute('aria-label',labels.phone);
    const initial = byCode.has(manualCountry) ? manualCountry : (byCode.has(detectedCountry) ? detectedCountry : 'AE');
    const field = {input,wrapper,select,flag:icon,country:initial,touched:!!input.value.trim()};
    const inferred = countryForNumber(input.value, initial);
    if (inferred) field.country = inferred;
    fields.add(field);
    paint(field);
    if (!input.value.trim()) setValue(input,'+' + byCode.get(field.country)[2] + ' ');
    select.addEventListener('change', () => choose(field,select.value,true));
    input.addEventListener('input', event => {
      if (event.isTrusted) field.touched = true;
      const inferred = countryForNumber(input.value, field.country);
      if (inferred && inferred !== field.country) {field.country = inferred; paint(field);}
      validate(field);
    });
    input.addEventListener('blur', () => {
      if (input.value.trim()) setValue(input, international(input.value,byCode.get(field.country)));
      validate(field);
    });
    if (input.form) {
      input.form.addEventListener('formdata', event => {
        if (!input.name) return;
        const number = international(input.value,byCode.get(field.country));
        event.formData.set(input.name, number === '+' + byCode.get(field.country)[2] ? '' : number);
      });
      input.form.addEventListener('reset', () => setTimeout(() => {field.touched=false; choose(field,manualCountry || detectedCountry,false);},0));
    }
    validate(field);
    detectCountry();
  }
  function scan(root) {
    if (root.nodeType !== 1 && root !== document) return;
    if (root.matches?.('input[type="tel"]')) enhance(root);
    root.querySelectorAll?.('input[type="tel"]').forEach(enhance);
  }
  scan(document);
  new MutationObserver(records => {
    records.forEach(record => record.addedNodes.forEach(scan));
    fields.forEach(field => {if (!field.input.isConnected) fields.delete(field);});
  }).observe(document.body,{childList:true,subtree:true});
})();
  } catch(e) { console.error(e); }
})();

})();
